import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContratoSelecionarTipoAssinaturaPage } from './contrato-selecionar-tipo-assinatura.page';

const routes: Routes = [
  {
    path: '',
    component: ContratoSelecionarTipoAssinaturaPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContratoSelecionarTipoAssinaturaPageRoutingModule { }
